// extracted by mini-css-extract-plugin
module.exports = {"AbandonedCarts":"AbandonedCarts_AbandonedCarts__8_AYf"};